import { render, staticRenderFns } from "./testPlace.vue?vue&type=template&id=60739647&scoped=true&"
import script from "./testPlace.vue?vue&type=script&lang=js&"
export * from "./testPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60739647",
  null
  
)

export default component.exports